// @ts-nocheck
import React from 'react';
import LegalModal from './LegalModal';
import tos from '../../assets/tos';

const TermsModal = ({ open, onClose, onAgree }) => (
  <LegalModal
    open={open}
    onClose={onClose}
    onAgree={onAgree}
    eyebrow="Legal · Terms"
    titleLead="Terms of"
    titleEm="Service"
    content={tos}
    fullLink="https://movology.com/terms"
  />
);

export default TermsModal;
